export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Getting Started
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            What Is <span className="text-primary-500">Sugargoo Spreadsheet</span>?
          </h2>
          <p className="text-foreground-600 max-w-3xl mx-auto leading-relaxed">
            Sugargoo Spreadsheet is an organized product discovery system designed to help international buyers find trending products faster and smarter. Instead of spending hours manually searching through endless listings, our curated spreadsheets bring together product categories, seller ratings, QC resources, and price comparisons into one streamlined, easy-to-navigate database.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-14">
          {[
            {
              icon: "ri-search-eye-line",
              title: "Organized Discovery",
              desc: "Browse curated product collections grouped by category, style, and trend — no more endless scrolling through unorganized marketplaces.",
            },
            {
              icon: "ri-scales-line",
              title: "Price Comparison",
              desc: "Compare prices across multiple sellers at a glance. Make informed buying decisions and save money on every purchase.",
            },
            {
              icon: "ri-camera-line",
              title: "QC Resources",
              desc: "Access quality control photos, measurement guides, and real buyer feedback to verify products before they ship to your warehouse.",
            },
            {
              icon: "ri-guide-line",
              title: "Buying Workflow",
              desc: "Follow a proven step-by-step buying process that takes you from product discovery to successful delivery with minimal hassle.",
            },
          ].map((item) => (
            <div
              key={item.title}
              className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/60 hover:border-primary-200 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h4 className="text-base font-semibold font-heading text-foreground-900 mb-2">
                {item.title}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="rounded-lg border border-background-200/70 overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-3.5 text-sm font-semibold text-foreground-700">
                  Traditional Searching
                </th>
                <th className="text-left px-5 py-3.5 text-sm font-semibold text-accent-700">
                  <i className="ri-arrow-right-line mr-1"></i>Sugargoo Spreadsheet
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ["Manual searching through thousands of listings", "Organized database with curated categories"],
                ["Hard to compare prices across sellers", "Easy side-by-side price comparison"],
                ["Time-consuming and frustrating", "Faster product discovery in seconds"],
                ["No category organization", "Multiple collections with smart filters"],
              ].map((row, i) => (
                <tr key={i} className="border-t border-background-200/40">
                  <td className="px-5 py-3 text-sm text-foreground-600">
                    <i className="ri-close-circle-line text-red-400 mr-2"></i>
                    {row[0]}
                  </td>
                  <td className="px-5 py-3 text-sm text-accent-700 font-medium">
                    <i className="ri-checkbox-circle-line text-accent-500 mr-2"></i>
                    {row[1]}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}